<template>
  <div class="loading-radio-box">
    <i class="icon iconfont iconicon_empty" @click="stopUpload"></i>
    <div class="loading-radio">
      <div class="progress-wrap">
        <el-progress :percentage="percentage" :show-text="false" :color="'#2682FF'"></el-progress>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      count: 3.6,
      rightDeg: 0,
      rightIndex: 1,
      value1: 0,
    };
  },
  computed: {
    getDeg() {
      return this.percentage * this.count;
    },
  },
  methods: {
    stopUpload() {
      this.$emit("stopUpload");
    },
  },
};
</script>
<style lang="scss">
.loading-radio-box {
  height: 6px;
  .iconicon_empty {
    position: absolute;
    top: 4px;
    right: 4px;
    cursor: pointer;
  }
  .iconicon_empty:hover {
    &::before {
      color: $color-active;
      background: #edf7f4;
    }
  }
  .iconicon_empty::before {
    font-size: 12px;
    content: "\E7BF";
    font-family: "iconfont";
    display: inline-block;
    padding: 6px;
    transform: scale(0.7);
    border-radius: 50%;
    background: #c3c6cb;
    text-align: center;
    line-height: 1;
    color: #fff;
  }
}
.loading-radio {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 111px;
  height: 0;
  .progress-wrap {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 111px;
    height: 0;
  }
  .loading-radio-1 {
    width: 30px;
    height: 60px;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
  }
  .loading-radio-2 {
    width: 30px;
    height: 60px;
    background-color: #fff;
    position: absolute;
    right: 0;
    top: 0;
  }
  .loading-radio-right {
    position: absolute;
    right: -5px;
    top: -5px;
    width: 35px;
    height: 65px;
    background-color: #ccc;
    transform-origin: 0 50%;
    z-index: 2;
  }
  .loading-radio-left---disable {
    position: absolute;
    left: -5px;
    top: -5px;
    width: 35px;
    height: 65px;
    background-color: #ccc;
    transform-origin: 0 50%;
    z-index: 0;
  }
  .loading-radio-right---disable {
    position: absolute;
    right: -5px;
    top: -5px;
    width: 35px;
    height: 65px;
    background-color: #fff;
    transform-origin: 0 50%;
    z-index: 1;
  }
}
</style>
